import type { UseMutationResult, UseMutationOptions } from 'react-query';
import { isSandboxEnvironment } from '../env-indicator';
import { toastFromPromise } from '../vy-toasts';
import type { VyToastFromPromiseRenderOptions } from '../vy-toasts/vy-toast-types/vy-toast-from-promise-render-options';

export async function runMutation<MutateResponse, MutateVariables>(
  mutation: UseMutationResult<MutateResponse, unknown, MutateVariables>,
  variables: MutateVariables,
  vyToastOptions: VyToastFromPromiseRenderOptions,
  options?: UseMutationOptions<MutateResponse, unknown, MutateVariables>,
) {
  if (isSandboxEnvironment()) {
    await mutation.mutateAsync(variables, options);

    return undefined;
  }

  return toastFromPromise(
    mutation.mutateAsync(variables, options),
    vyToastOptions,
  );
}